import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import { ILicense } from '../../../../models/License'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'
import Badge from './Badge'
import HeaderWrapper from './HeaderWrapper'
import Label from './Label'

function Header({
  t,
  validLicenses,
  style,
  label,
  active,
  size = 1,
}: IWithSize & WithTranslation & IHeader) {
  return (
    <HeaderWrapper size={size} alignCenter={true} row={true} style={style}>
      <Flex>
        <Label active={active} size={size}>
          {label}
        </Label>
      </Flex>
      <Flex full={true} alignCenter={true} justifyEnd={true}>
        <Badge active={active} size={size}>
          {validLicenses.length}
        </Badge>
      </Flex>
    </HeaderWrapper>
  )
}

export default withTranslation()(Header)

export interface IHeader {
  validLicenses?: ILicense[]
  active?: boolean
  label?: string
  style?: React.CSSProperties
}
